module.exports = __webpack_public_path__ + "img/F962.3a7726b4.jpg";